import { useNavigate } from 'react-router'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { FormImage } from '../../../Form/FormImage/FormImage.js'
import { T } from '../../../i18n/index.js'

import { NewGroupNameField } from './NewGroupNameField.js'
import { SelectedMembersList } from './SelectedMembersList.js'

interface Props {
  isCreatingGroup: boolean
}

export const NewGroupChat = ({ isCreatingGroup }: Props) => {
  const navigate = useNavigate()

  return (
    <div className="grow flex flex-col pb-8 p-3 flex flex-col grow gap-y-7 animate-fade-in overflow-y-auto">
      <div className="flex flex-col">
        <Text className="font-medium text-lg truncate text-content grow">
          <T defaultMessage="Group settings" id="Generics.GroupSettings" />
        </Text>
        <Text className="text-xs text-content-muted">
          <T
            defaultMessage="Customize your new group"
            id="Messaging.NewGroupChat.GroupSettings.Description"
          />
        </Text>
      </div>
      <div className="flex flex-col grow">
        <div className="w-full flex flex-col gap-y-7">
          <FormImage
            cropable
            name="avatar"
            variant="avatar"
            multiple={false}
            label={
              <Text className="text-sm text-content-muted">
                <T
                  defaultMessage="Group avatar"
                  id="Messaging.NewGroupChat.AvatarField.Label"
                />
              </Text>
            }
          />
          <div className="w-full">
            <NewGroupNameField />
          </div>
          <div className="self-start w-full">
            <SelectedMembersList />
          </div>
        </div>
      </div>
      <div className="flex gap-x-3 self-end justify-end">
        <Button
          variant="secondaryNeutral"
          size="md"
          onClick={() => navigate('/messaging')}
        >
          <T defaultMessage="Cancel" id="Generics.Cancel" />
        </Button>
        <Button
          variant="primary"
          size="md"
          type="submit"
          loading={isCreatingGroup}
          disabled={isCreatingGroup}
        >
          <T defaultMessage="Create group" id="Generics.CreateGroup" />
        </Button>
      </div>
    </div>
  )
}
